module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container"
  }, [_c('span', {
    staticClass: "oldId",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "turnplate"
  }, [_c('canvas', {
    staticClass: "item",
    attrs: {
      "id": "wheelcanvas"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "pointer",
    attrs: {
      "src": require("assets/images/lottery/but_dianjichoujiang.png"),
      "data-root": _vm.canRotate
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.history
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.getActivityList.winningRecordPicture,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, _vm._l((_vm.getActivityList.prizeExplain), function(item, index) {
    return _c('p', {
      key: index,
      staticClass: "f10"
    }, [_vm._v(_vm._s(item))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('h1', {
    staticClass: "f14"
  }, [_vm._v("活动规则：")]), _vm._v(" "), _vm._l((_vm.getActivityList.activityRule), function(item, index) {
    return _c('p', {
      key: index,
      staticClass: "f10"
    }, [_vm._v(_vm._s(item))])
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPopup),
      expression: "showPopup"
    }],
    staticClass: "layer",
    on: {
      "click": function($event) {
        _vm.showPopup = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "activity"
  }, [(_vm.activityStatus == 1002) ? [_c('img', {
    attrs: {
      "src": require("../assets/images/lottery/1002.png"),
      "alt": ""
    }
  })] : _vm._e(), _vm._v(" "), (_vm.activityStatus == 1003) ? [_c('img', {
    attrs: {
      "src": require("../assets/images/lottery/1003.png"),
      "alt": ""
    }
  })] : _vm._e(), _vm._v(" "), (_vm.activityStatus == 1005) ? [_c('img', {
    attrs: {
      "src": require("../assets/images/lottery/1005.png"),
      "alt": ""
    }
  })] : _vm._e(), _vm._v(" "), (_vm.activityStatus == 1006) ? [_c('img', {
    attrs: {
      "src": require("../assets/images/lottery/1006.png"),
      "alt": ""
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPopup),
      expression: "showPopup"
    }],
    staticClass: "pop-up"
  }, [_c('h1', {
    staticClass: "title_yy"
  }, [_vm._v("中奖纪录")]), _vm._v(" "), (_vm.isAwar) ? [_c('div', {
    staticClass: "content",
    class: {
      flex: _vm.prizeList[_vm.index] == '谢谢参与'
    }
  }, [_c('h1', {
    staticClass: "f44"
  }, [_vm._v(_vm._s(_vm.prizeList[_vm.index]))]), _vm._v(" "), (_vm.prizeList[_vm.index] != '谢谢参与') ? [_c('p', {
    staticClass: "desc f16"
  }, [_vm._v(_vm._s(_vm.spoilList[_vm.index]))]), _vm._v(" "), _c('a', {
    staticClass: "button f24",
    class: {
      'disable': _vm.hasExchanged
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.exchange
    }
  }, [_vm._v("\n              " + _vm._s(_vm.words) + "\n            ")])] : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("注：" + _vm._s(_vm.awardRemark) + "!")])], 2)] : [_c('div', {
    staticClass: "content_ccc"
  }, [_c('ul', [_vm._m(0), _vm._v(" "), _vm._l((_vm.tableData), function(item) {
    return _c('li', {
      key: item.id
    }, [_c('span', {
      staticClass: "jiangx"
    }, [_vm._v(_vm._s(item.awardName))]), _vm._v(" "), _c('span', {
      staticClass: "jiangp"
    }, [_vm._v(_vm._s(item.prizeName))]), _vm._v(" "), _c('span', {
      staticClass: "state"
    }, [(item.state === 1) ? _c('span', [_vm._v("\n                 未兑换"), _c('img', {
      attrs: {
        "src": require("../assets/images/lottery/button.png"),
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.kkkk(item)
        }
      }
    })]) : _c('span', [_vm._v("\n                 已兑换\n               ")])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "op",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-pagination', {
    attrs: {
      "small": "",
      "background": "",
      "layout": "prev, pager, next",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.changDate
    }
  })], 1)]], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "jiangx"
  }, [_vm._v("奖项")]), _vm._v(" "), _c('span', {
    staticClass: "jiangp"
  }, [_vm._v("奖品")]), _vm._v(" "), _c('span', {}, [_vm._v("状态")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43fb051a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lottery.vue
// module id = 324
// module chunks = 1